import { EmailOutlined, HelpOutline } from "@mui/icons-material";
import { Link, SpeedDial, SpeedDialAction } from "@mui/material";
import { bindTrigger, usePopupState } from "material-ui-popup-state/hooks";
import { Link as RouterLink, useLocation } from "react-router-dom";

import BugReportDialog from "./BugReportDialog";
import HelpDialog from "./HelpDialog";
import SuggestionsDialog from "./SuggestionsDialog";

function Feedback() {
  const helpPopupState = usePopupState({ variant: "dialog", popupId: "help" });
  const bugReportPopupState = usePopupState({
    variant: "dialog",
    popupId: "bugReport",
  });
  const suggestionsPopupState = usePopupState({
    variant: "dialog",
    popupId: "suggestions",
  });

  const location = useLocation();

  const actions = [
    {
      show: true,
      icon: <EmailOutlined color="primary" />,
      name: "Help!",
      ...bindTrigger(helpPopupState),
    },
    {
      show: true,
      icon: (
        <Link
          component={RouterLink}
          to="/faq"
          sx={{
            color: "gray",
            position: "relative",
            top: 4,
            "&:hover": {
              color: "gray",
            },
          }}
        >
          <HelpOutline color="primary" />
        </Link>
      ),
      name: "Visit FAQ page",
    },
  ];

  return (
    <>
      {!location.pathname.startsWith("/map") && (
        <SpeedDial
          ariaLabel="Feedback forms"
          sx={{
            position: "absolute",
            bottom: 16,
            right: 16,
          }}
          FabProps={{
            sx: {
              bgcolor: "secondary.main",
            },
          }}
          icon={<HelpOutline fontSize="large" />}
        >
          {actions.map(
            ({ show, ...actionProps }) =>
              show && (
                <SpeedDialAction
                  {...actionProps}
                  key={actionProps.name}
                  icon={actionProps.icon}
                  slotProps={{ tooltip: { title: actionProps.name } }}
                />
              ),
          )}
        </SpeedDial>
      )}
      <HelpDialog {...helpPopupState} />
      <SuggestionsDialog {...suggestionsPopupState} />
      <BugReportDialog {...bugReportPopupState} />
    </>
  );
}

export default Feedback;
